export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const CHANGE_SYSTEM_STATUS = 'CHANGE_SYSTEM_STATUS';
export const BY_PASS_MAINTENANCE_MODE = 'BY_PASS_MAINTENANCE_MODE';

export default {
  TOGGLE_SIDEBAR,
  CHANGE_SYSTEM_STATUS,
  BY_PASS_MAINTENANCE_MODE,
};
